module.exports = __webpack_public_path__ + "assets/img/report_l5.cf30431c.png";